import { render, staticRenderFns } from "./QRScan.vue?vue&type=template&id=27b1d42c"
import script from "./QRScan.vue?vue&type=script&lang=js"
export * from "./QRScan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports